import { useCallback, useMemo } from 'react';
import { Icon, Modal } from 'ui';

export const useConfirmDelete = () => {
  const [modal, contextHolder] = Modal.useModal();

  const confirm = useCallback(
    ({ onOk, title }: { onOk: () => Promise<void>; title: string }) => {
      modal.confirm({
        content: 'This action is irreversible.',
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Delete',
        onOk,
        title,
        type: 'error',
      });
    },
    [modal],
  );

  return useMemo(
    () => ({
      confirm,
      contextHolder,
    }),
    [confirm, contextHolder],
  );
};
